// src/config.ts

// アプリケーションのベースパス設定
// 環境変数から取得。未定義の場合は '/' をデフォルトとする
export const APP_BASE_PATH: string = process.env.REACT_APP_APP_BASE_PATH || '/';

// バックエンドのベースパス設定
// 環境変数から取得。未定義の場合は空文字列をデフォルトとする
export const API_BASE_PATH: string = process.env.REACT_APP_API_BASE_PATH || 'https://stgb.acs-l.jp/backend';

// ACS-Light APIの基本パス
export const ACS_LIGHT_API_BASE_PATH: string = process.env.REACT_APP_ACS_LIGHT_API_BASE_PATH || 'https://stg.acs-l.jp';

// 単一ロード(Flutterハンドシェイク)機能の有効フラグ（緊急スイッチ）。
// 新Flutterは window.__flutterSingleLoad=true を立て、/ をロード後に認証データを
// IndexedDB へ注入し window.__flutterAuthInjected=true（+__flutterAuthReadyResolve）で
// 通知する。Web はこれを待ってから復元することで /login 往復（二重フルロード）を避ける。
// 万一この経路が問題を起こした場合は、ここを false にして再デプロイ（Webは即時反映）すれば、
// 新Flutterでも従来の /login 往復注入フォールバックへ退避できる。
export const SINGLE_LOAD_ENABLED: boolean = true;

// サブパスを考慮したルートパスを返す関数
export const getRoutePath = (path: string) => {
  // 開発環境またはルートにデプロイされている場合はそのまま返す
  return path;
};

// ルートパス定義（アプリケーション内で参照する際に使用）
export const ROUTES = {
  LOGIN: '/login',
  MENU: '/menu',
  CAMERA: '/camera',
  EDIT: '/edit',
  ADDITIONAL_INFO: '/additional-info',
  FOLLOW_REGISTRATION: '/follow-registration',
  BUSINESS_CARD_LIST: '/business-card-list',
  BUSINESS_CARD_DETAIL: '/business-card-detail'
};

// 各APIエンドポイントのパス
export const API_PATHS = {
  UPLOAD_IMAGE: `${API_BASE_PATH}/upload_image.php`,
  PROCESS_OCR: `${API_BASE_PATH}/process_ocr.php`,
  DELETE_IMAGE: `${API_BASE_PATH}/delete_image.php`,
  //BUSINESS_CARD_API: `${API_BASE_PATH}/customer_edit.php`, // 顧客データのCREATEエンドポイント
};

// 添付ファイル関連API
export const ATTACHMENT_LIST_API = `${ACS_LIGHT_API_BASE_PATH}/api2/attachfile/selectList`;
export const ATTACHMENT_DELETE_API = `${ACS_LIGHT_API_BASE_PATH}/api2/attachfile/delete`;
export const ATTACHMENT_DOWNLOAD_API = `${API_BASE_PATH}/download_attachment.php`;

// 音声アップロードとAI清書のAPIエンドポイント
export const AUDIO_UPLOAD_API = `${API_BASE_PATH}/upload_audio.php`;
export const AUDIO_TRANSCRIPTION_API = `${API_BASE_PATH}/process_audio_transcription.php`;
export const TEXT_SUMMARY_API = `${API_BASE_PATH}/process_text_summary.php`;

// フォロー登録/更新/削除 API（ACS-Light）
export const FOLLOW_EDIT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/edit`;

// フォロー取得API（全件）
export const FOLLOW_SEARCH_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/search`;

// フォロー取得API（1件）
export const FOLLOW_SELECT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/select`;

// アポイント一覧取得API
export const APPOINT_LIST_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/appointlist`;

// 目的一覧取得API
export const PURPOSE_LIST_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/purposelist`;

// フォロー通知送信API
export const FOLLOW_NOTICE_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/notice`;

// フォロー通知先取得API（担当者・Teamsチャネル一覧）
export const FOLLOW_GET_NOTICE_DESTINATION_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/getNoticeDestination`;

// ホーム画面 ToDoカウント取得API（followUnreadCount を含む）
export const HOME_TODO_COUNT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/home/getTodoCount`;

// フォロー通知履歴取得API
export const FOLLOW_NOTICE_HISTORY_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/searchNoticeHistory`;

// フォロー未読化API
export const FOLLOW_UNREAD_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/unread`;

// 関連フォローAPI
// 同じ関連フォロー群のフォロー一覧取得
export const LINKEDFOLLOW_ALL_API = `${ACS_LIGHT_API_BASE_PATH}/api2/linkedfollow/allFollow`;
// 紐づけ対象として選択可能なフォロー検索
export const LINKEDFOLLOW_SEARCH_API = `${ACS_LIGHT_API_BASE_PATH}/api2/linkedfollow/search`;
// フォローの紐づけ追加
export const LINKEDFOLLOW_ADD_LINK_API = `${ACS_LIGHT_API_BASE_PATH}/api2/linkedfollow/addLink`;
// フォローの切り離し（1件）
export const LINKEDFOLLOW_CUT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/linkedfollow/cutFollow`;
// フォローの切り離し（全件・群解散）
export const LINKEDFOLLOW_CUT_ALL_API = `${ACS_LIGHT_API_BASE_PATH}/api2/linkedfollow/cutFollowAll`;

// フォローコメントAPI
// コメント一覧取得
export const FOLLOW_GET_COMMENTS_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/getComments`;
// コメント保存（新規／編集）
export const FOLLOW_SAVE_COMMENT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/saveFollowComment`;
// コメント削除
export const FOLLOW_DELETE_COMMENT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/follow/deleteComment`;

// ランク一覧取得API
export const RANK_SEARCH_API = `${ACS_LIGHT_API_BASE_PATH}/api2/rank/search`;

// 担当者一覧取得API
export const CONTACT_USERS_API = `${ACS_LIGHT_API_BASE_PATH}/api2/user/selectcontactuserlist`;

// キーワード検索API
export const KEYWORD_SEARCH_API = `${ACS_LIGHT_API_BASE_PATH}/api2/keyword/search`;

// アシストテキスト一覧取得API
export const ENQUETE_SEARCH_API = `${ACS_LIGHT_API_BASE_PATH}/api2/enquete/search`;

// アシストテキスト詳細取得API
export const ENQUETE_SELECT_INPUT_ASSIST_API = `${ACS_LIGHT_API_BASE_PATH}/api2/enquete/selectinputassist`;

// 自社紹介文＆専門用語取得API
export const KNOWLEDGE_GET_LIST_API = `${ACS_LIGHT_API_BASE_PATH}/api2/knowledge/getknowledgelist`;

// 顧客地図API（参考: ref/map の /api/map/*。サーバーが up-tone 用に /api2/map/* として実装）
export const CUSTOMER_MAP_INIT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/map/init`;
export const CUSTOMER_MAP_SELECT_API = `${ACS_LIGHT_API_BASE_PATH}/api2/map/select`;
export const CUSTOMER_MAP_REPAGE_API = `${ACS_LIGHT_API_BASE_PATH}/api2/map/repage`;
